export const CLEAR_VERIFICATION_DATA = 'CLEAR_VERIFICATION_DATA';
